
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clever-login",
      function () {
        return require("private-next-pages/clever-login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clever-login"])
      });
    }
  